import axios from "axios";
import { NotImplementedError } from "../../errors";
import { PromiseHandler } from "../../handlers";
import { ExternalSegmentsFetchFailed } from "./errors";
import { externalSegmentFromService } from "./types";
import { toQueryParams } from "./filters";
export default class ExtSegments extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "ext-segments");
        this.url = `${this.sdk.urls.baseAPIUrl}/ext-segments`;
    }
    async findItems(filters, sort) {
        const params = toQueryParams(filters, sort);
        const url = `${this.url}${params}`;
        return this.cache.promise(url, () => axios
            .get(url)
            .then(({ data }) => {
            return Array.isArray(data?.data) ? data.data.map(externalSegmentFromService) : [];
        })
            .catch(() => {
            throw new ExternalSegmentsFetchFailed();
        }));
    }
    async saveItem() {
        throw new NotImplementedError("save");
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
export * from "./types";
//# sourceMappingURL=index.js.map